/* Constants for SIGSAOP */
import { REGIONES_LIST as REGIONES_CHILE } from "./chile_geo";

export { REGIONES_CHILE };

export const TIPO_VINCULO_COM = ["Operacional", "Voluntario"];
export const TIPO_VINCULO_AUT = ["Administrativo", "Voluntario"];

export const ENTITY_TYPES_AUTH = [
  { value: "comunal", label: "Autoridad Comunal" },
  { value: "gobierno", label: "Gobierno / Delegación / Seremis" },
  { value: "parlamentario", label: "Parlamentario (Senador / Diputado)" },
  { value: "gore", label: "Autoridad GORE" },
  { value: "organizacion", label: "Organización / Gremio / Institución" },
];

// Categorías por tipo de entidad — usadas tanto en creación como en filtro
export const CATEGORIAS_AUTH = {
  comunal: [
    "Alcaldía",
    "Concejo Municipal",
    "DIDECO / Desarrollo Comunitario",
    "Unidad municipal",
    "Otro",
  ],
  gobierno: [
    "Delegación Presidencial Regional",
    "Delegación Presidencial Provincial",
    "SEREMI",
    "Otro",
  ],
  parlamentario: [
    "Senador",
    "Diputado",
    "Otro",
  ],
  gore: [
    "Gobernador Regional",
    "Consejo Regional (CORE)",
    "Unidad GORE",
    "Otro",
  ],
  organizacion: [
    "Junta de Vecinos",
    "Sindicato",
    "Asociación gremial",
    "ONG / Fundación",
    "Comité",
    "Empresa privada",
    "Cooperativa",
    "Otro",
  ],
};

export const COMMITMENT_TIPOS = [
  { value: "rca", label: "RCA" },
  { value: "operacional", label: "Operacional" },
  { value: "voluntario", label: "Voluntario" },
  { value: "comunitario", label: "Comunitario" },
  { value: "ambiental", label: "Ambiental" },
  { value: "institucional", label: "Institucional" },
];

export const COMMITMENT_ESTADOS = [
  "pendiente","en_proceso","cumplido","vencido","reprogramado","cancelado",
];

export const PROJECT_ESTADOS = [
  "planificacion","en_ejecucion","pausado","cerrado","cancelado",
];

export const EJES_ESTRATEGICOS = [
  "ODS","ICMM","Copper Mark","Política interna","RCA","Ambiental","Social","Operacional",
];

export const COMPONENTES_AMBIENTALES = [
  "agua","aire","suelo","biodiversidad","patrimonio","comunidad","emisiones","residuos","otro",
];

export const ROLES = [
  { value: "super_admin", label: "Super Admin" },
  { value: "admin_empresa", label: "Administrador Empresa" },
  { value: "gerente", label: "Gerente / Ejecutivo" },
  { value: "encargado_social", label: "Encargado Social" },
  { value: "encargado_ambiental", label: "Encargado Ambiental" },
  { value: "encargado_proyecto", label: "Encargado Proyecto" },
  { value: "consulta", label: "Usuario Consulta" },
  { value: "auditor", label: "Auditor / Certificador" },
];

export const RELATED_ENTITY_TYPES = [
  { value: "community", label: "Comunidad" },
  { value: "authority", label: "Autoridad" },
  { value: "project", label: "Proyecto" },
  { value: "rca", label: "RCA" },
];

export const MEETING_TIPOS = [
  { value: "Coordinación", label: "Coordinación" },
  { value: "Seguimiento", label: "Seguimiento" },
  { value: "Operativa", label: "Operativa" },
  { value: "Asamblea", label: "Asamblea" },
  { value: "Mesa de diálogo", label: "Mesa de diálogo" },
  { value: "Mesa territorial", label: "Mesa territorial" },
  { value: "Institucional", label: "Institucional" },
  { value: "Cierre", label: "Cierre" },
  { value: "Negociación", label: "Negociación" },
  { value: "Información a la comunidad", label: "Información a la comunidad" },
  { value: "Otro", label: "Otro" },
];
